import React from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { alpha } from "@mui/material/styles";
import AgentConfigSection from "../../AgentConfigSection";

export default function DeleteAgentSection({
  name,
  deleteConfirmText,
  setDeleteConfirmText,
  deleting,
  handleDelete,
}) {
  const confirmed = deleteConfirmText === name;

  return (
    <AgentConfigSection id="deleteAgent">
      <Box
        sx={{
          border: 1,
          borderColor: "error.light",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 1.5,
            backgroundColor: (theme) => alpha(theme.palette.error.main, 0.05),
            borderBottom: 1,
            borderColor: "error.light",
          }}
        >
          <WarningAmberIcon sx={{ fontSize: 18, color: "error.main" }} />
          <Typography
            sx={{ fontSize: "14px", fontWeight: 600, color: "error.dark" }}
          >
            Delete this agent
          </Typography>
        </Box>
        <Box sx={{ px: 2, py: 2 }}>
          <Typography
            sx={{
              fontSize: "13px",
              color: "text.secondary",
              mb: 2,
              lineHeight: 1.5,
            }}
          >
            This will permanently delete the agent <strong>{name}</strong>, all
            of its chat sessions, knowledge files, configuration, and email
            inbox. This action cannot be undone.
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "text.secondary", mb: 1 }}>
            To confirm, type <strong>{name}</strong> below:
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={deleteConfirmText}
            onChange={(e) => setDeleteConfirmText(e.target.value)}
            placeholder={name}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                fontSize: "13px",
                borderRadius: "6px",
                "& fieldset": { borderColor: "error.light" },
                "&:hover fieldset": { borderColor: "error.light" },
                "&.Mui-focused fieldset": { borderColor: "error.main" },
              },
            }}
          />
          <Button
            fullWidth
            onClick={handleDelete}
            disabled={!confirmed || deleting}
            sx={{
              textTransform: "none",
              fontSize: "13px",
              fontWeight: 600,
              borderRadius: "6px",
              py: 1,
              backgroundColor: confirmed
                ? "error.main"
                : (theme) => alpha(theme.palette.error.main, 0.2),
              color: confirmed ? "error.contrastText" : "error.light",
              border: 1,
              borderColor: confirmed
                ? "error.main"
                : (theme) => alpha(theme.palette.error.main, 0.2),
              "&:hover": {
                backgroundColor: "error.dark",
                borderColor: "error.dark",
              },
              "&.Mui-disabled": {
                backgroundColor: (theme) =>
                  alpha(theme.palette.error.main, 0.2),
                color: "error.light",
                borderColor: (theme) => alpha(theme.palette.error.main, 0.2),
              },
            }}
          >
            {deleting ? "Deleting..." : "I understand, delete this agent"}
          </Button>
        </Box>
      </Box>
    </AgentConfigSection>
  );
}
